<template>
	<div class="main">
		<loader></loader>
		<header class="page-title">
			<h2>New Loophole</h2>
			<div class="ml-auto">
				<a @click.prevent="saveLoophole" class="btn btn-md btn-success"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>

		<div class="card">
			<header class="card-header language-list">
				<lang-selector></lang-selector>
			</header>
			<div class="card-body">
				<div class="form-group">
					<label for="title">Loophole Title<sup class="text-danger">*</sup></label>
					<input id="title" type="text" v-model="loophole.translations[clickedLang].title">
					<p class="input-error" v-if="errors.errors.title">{{ errors.errors.title }}</p>
				</div>
				<div class="form-group">
					<label for="content">Loophole Content<sup class="text-danger">*</sup></label>
					<editor
							v-model="loophole.translations[clickedLang].content"
							id="content"
							:api-key="tinyMCEApiKey"
							:init="tinyMCEConfig"
					/>
					<p class="input-error" v-if="errors.errors.content">{{ errors.errors.content }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {eventBus} from "../../app";
import Errors from "../../Utils/Errors";

export default {
	name: "LoopholeCreate",
	data() {
		return {
			loophole: {
				translations: {},
				preview: {}
			},

			availableLanguages: this.$availableLanguages,
			clickedLang: this.$defaultLanguage.locale,

			tinyMCEApiKey: this.$tinyMCEApiKey,
			tinyMCEConfig: this.$tinyMCEConfig,

			errors: new Errors(),
		}
	},
	created() {
		let vm = this;

		// When setActiveStatus method ran, change selected data in form fields
		/* From LangSelector */
		eventBus.$on('setActiveStatus', function (clickedLang) {
			vm.clickedLang = clickedLang;
		});

		for (let i = 0; i < vm.$availableLanguages.length; i++) {
			vm.loophole.translations[vm.$availableLanguages[i].locale] = {};
			vm.loophole.translations[vm.$availableLanguages[i].locale]['title'] = '';
			vm.loophole.translations[vm.$availableLanguages[i].locale]['content'] = '';

			vm.loophole.preview[vm.$availableLanguages[i].locale] = {
				'title': '',
				'content': ''
			};
		}
	},
	methods: {
		saveLoophole: function () {
			let vm = this;
			eventBus.$emit('onLoaderStart');

			axios.post('/api/' + vm.$selectedSite.slug + '/loophole', vm.loophole.translations)
				.then(function (response) {
					if (response) {
						eventBus.$emit('onLoaderFinish');
						vm.$toastr.success('Loophole saved.', 'Success');
						setTimeout(function () {
							window.location.replace('/' + vm.$selectedSite.slug + '/loophole/' + response.data.success.id + '/edit');
						}, 1500);
					} else {
						eventBus.$emit('onLoaderFinish');
						vm.$toastr.error('Loophole save failed.', 'Error');
					} // if
				}).catch(function (e) {
				vm.$toastr.error('Loophole saving failed.', 'Error');
				vm.errors.record(e.response.data);
			});
		}
	}
}
</script>

<style scoped>

</style>
